// import { useEffect, useState } from "react";
// import { useApp } from "@modelcontextprotocol/ext-apps/react";
import type { App as McpApp } from "@modelcontextprotocol/ext-apps";
import { LoadingIndicator } from "@openai/apps-sdk-ui/components/Indicator";
import { useOpenAiGlobal } from "../use-openai-global";

interface ResumeParserOutput {
  toolName: string;
  success: boolean;
  parserResult?: any;
}

export default function App() {
  const toolOutput = useOpenAiGlobal("toolOutput") as ResumeParserOutput | null;
  const resumeStruct = toolOutput?.parserResult;
  // const [data, setData] = useState<ResumeParserOutput | null>(null);
  // const { app, error } = useApp({
  //   appInfo: { name: "Show Resume Parser Result", version: "1.0.0" },
  //   capabilities: {},
  //   onAppCreated: (app: McpApp) => {
  //     app.ontoolresult = (result: any) => {
  //       setData(result.structuredContent as unknown as ResumeParserOutput);
  //     };
  //   },
  // });

  // useEffect(() => {
  //   if (error) {
  //     console.error("Error initializing app:", error);
  //   }
  //   if (app) {
  //     console.log("App initialized successfully:", app);
  //     console.log("tool name:", data?.toolName);
  //     console.log("parser result:", data?.parserResult);
  //     console.log("success:", data?.success);
  //   }
  // }, [error, app, data]);

  // if (error) {
  //   return (
  //     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
  //       Error initializing app: {error.message}
  //     </div>
  //   );
  // }
  // if (!app || data === undefined) {
  //   return (
  //     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
  //       <div className="flex items-center gap-2">
  //         <LoadingIndicator
  //           size = {20}
  //           strokeWidth={2}
  //         />
  //         Resume Parsing...
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
      { resumeStruct ? (
        <div className="flex items-center gap-2">
          <span>Resume Parsed Successfully!</span>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <LoadingIndicator
            size = {20}
            strokeWidth={2}
          />
          Resume Parsing...
        </div>
      )
      }
      {/* <pre>{JSON.stringify(resumeStruct, null, 2)}</pre> */}
    </div>
  );
}
